import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ClinicFilterService } from '../../state/clinic-filter/clinic-filter.service';

@Component({
    standalone: false,
    selector: 'app-location-filter-modal',
    templateUrl: './location-filter-modal.component.html',
    styleUrls: ['./location-filter-modal.component.scss'],
})
export class LocationFilterModalComponent {
    @Input() availableCities: string[] = [];
    @Input() onClear?: () => void;
    searchText = '';
    stagedCity: string | null = null;

    constructor(
        private modalController: ModalController,
        public clinicFilterService: ClinicFilterService
    ) {
        this.stagedCity = this.clinicFilterService.activeCity();
    }

    private normalizeText(text: string): string {
        return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    filteredCities(): string[] {
        const normalizedSearch = this.normalizeText(this.searchText);
        return this.availableCities.filter((city) => {
        return this.normalizeText(city).includes(normalizedSearch);
        })
    }

    selectLocation(city: string, checked: boolean): void {
        this.stagedCity = checked ? city : null;
    }

    get hasNoChanges(): boolean {
        const activeCity = this.clinicFilterService.activeCity();
        return this.stagedCity === activeCity;
    }

    close(): void {
        this.modalController.dismiss();
    }

    confirm(): void {
        if (this.hasNoChanges) return;
        this.clinicFilterService.setCity(this.stagedCity);
        this.modalController.dismiss({ confirmed: true });
    }

    clearFilters(): void {
        this.clinicFilterService.setCity(null);
        this.clinicFilterService.setTags([]);
        this.stagedCity = null;
        this.onClear?.();
    }
}
